import { InputProps } from '@toggle/design-system';
import React, { ChangeEventHandler, FC } from 'react';

import * as S from './BaseRenameInput.styles';

interface BaseRenameInputProps extends InputProps {
  className?: string;
  value: string;
  onChange: ChangeEventHandler<HTMLInputElement>;
  showLengthIndicator?: boolean;
}

export const BaseRenameInput: FC<BaseRenameInputProps> = ({
  className,
  value,
  onChange,
  showLengthIndicator = true,
  maxLength = 30,
  ...rest
}) => {
  return (
    <S.StyledInput
      className={className}
      data-testid="base-rename-input"
      value={value}
      onChange={onChange}
      maxLength={maxLength}
      rightIcon={
        showLengthIndicator ? `${value.length}/${maxLength}` : undefined
      }
      {...rest}
    />
  );
};
